<script>

	export default {
		props: [
            

		],
        data: function(){
			return {
                title: null,
                route: null,
                event: null,
                model: null,
                path: null,
                elementname: null,
				item: {},
                errors: [],
                itemName: "",
                document_download: {name: null, data: null},
                tabs: null,
                tabIndex: null,
                related_data: {},
                has_related_data: false,
			};
		},
		mounted() {
            this.errors = [];
            if(this.has_related_data) {
                axios.get(this.route + '/relatedData').then((res) => {
                    this.related_data = res.data;
                    this.loadItem();
                });
            }
            else {
                this.loadItem();
            }
        },
		methods: {
			loadItem() {
                this.setLoading(true);

                axios.get(this.route + '/' + this.$route.params.id).then((res) => {
					this.item = res.data[this.model];

                    this.setLoading(false);
				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "load");
                    this.$router.push({path: "/" + this.event + "-list"});
                });
            },

            openEdit() {
                var route = {path: "/" + this.event + "-list" + "/" + this.event + '-edit/' + this.item.id};
                
                if(this.tabs) {
                    route.path += this.tabs[this.tabIndex];
                }
                
                this.$router.push(route);
			},
            closePanel(change) {
                if(change) {
                    this.$emit("change");
                }
                this.$router.push({path: "/" + this.event + "-list"});
            },
            deleteItem(event) {
                this.$modal.show('dialog', {
                    title: 'Delete ' + this.tBrandKey(this.elementname),
                    text: "You are about to delete " + this.tBrandKey(this.elementname).toLowerCase() + " " + this.getName() + ". Are you sure you want to continue?",
                    buttons: [
                    {
                        title: 'Yes',
                        handler: () => {
                            this.$modal.hide('dialog');
                            this.setLoading(true);
                            axios.delete(this.route + '/' + this.item.id).then((res) => {
                                console.log(res.data);
                                this.setLoading(false);
                                this.addNotification({type: "success", content: this.tBrandKey(this.elementname) + " " + this.getName() + " deleted successfully."});
                                this.item.id = null;
                                this.originalData = null;
                                this.closePanel(true);
                            }).catch((error) => {
                                this.setLoading(false);
                                this.handleError(error, "delete");
                            });
                        },
                    },
                    {
                        title: 'Cancel',
                        default: true
                    }]});
            },
            getName() {
                return this.name;
            }
        }
    }
</script>
